var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-popup" }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "exportToLogoWebAgencyPopup",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "contact-form-action" }, [
                  _c("div", { staticClass: "col-lg-12" }, [
                    _vm.logoExportStatusList != null
                      ? _c(
                          "div",
                          { staticClass: "card-item" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _vm._l(
                              _vm.logoExportStatusList,
                              function (exportStatus) {
                                return _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "contact-form-action col-sm-6",
                                    },
                                    [
                                      _c("div", { staticClass: "input-box" }, [
                                        _c(
                                          "label",
                                          { staticClass: "label-text" },
                                          [
                                            _vm._v(
                                              _vm._s(exportStatus.bookingNumber)
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "contact-form-action col-sm-3",
                                    },
                                    [
                                      _c("div", { staticClass: "input-box" }, [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "label-text",
                                            class: _vm.getStatusClass(
                                              exportStatus.status
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getStatusText(
                                                  exportStatus.status
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "contact-form-action col-sm-3",
                                    },
                                    [
                                      exportStatus !== "ok"
                                        ? _c(
                                            "div",
                                            { staticClass: "input-box" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "a-logo-export",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.sendToLogo(
                                                        exportStatus.bookingNumber,
                                                        exportStatus.sailId
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Aktar")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contact-form-action ml-4" }),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h3", { staticClass: "title mb-2 ml-3" }, [
        _vm._v("Web Acentesi Logo Aktarım Durumu"),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [
          _c("span", {
            staticClass: "la la-close",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "contact-form-action col-sm-6" }, [
        _c("div", { staticClass: "input-box" }, [
          _c("label", { staticClass: "font-weight-bold label-text" }, [
            _vm._v("Rezervasyon No"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-form-action col-sm-3" }, [
        _c("div", { staticClass: "input-box" }, [
          _c("label", { staticClass: "font-weight-bold label-text" }, [
            _vm._v("Durumu"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-form-action col-sm-3" }, [
        _c("div", { staticClass: "input-box" }, [
          _c("label", { staticClass: "font-weight-bold label-text" }, [
            _vm._v("Aktar"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }